import { render, staticRenderFns } from "./SectionAthlete.vue?vue&type=template&id=250c1ae5&scoped=true&"
import script from "./SectionAthlete.vue?vue&type=script&lang=js&"
export * from "./SectionAthlete.vue?vue&type=script&lang=js&"
import style0 from "./SectionAthlete.vue?vue&type=style&index=0&id=250c1ae5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250c1ae5",
  null
  
)

export default component.exports